import { useTheme } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React, { SVGProps, useId } from 'react';
import type { CustomSvgIconsProps, SvgPathProps } from './CustomSvgIcons.types';

const SvgPath = ({
  iconType,
  shapeId,
  solidColor,
}: SvgPathProps): React.ReactElement => {
  const iconTypeToStrokeWidth = {
    bold: '0.6',
    normal: '0.4',
    thin: '0.2',
  };

  const strokeWidth = iconTypeToStrokeWidth[iconType || 'normal'];
  const commonPathProps: SVGProps<SVGPathElement> = {
    clipRule: 'nonzero',
    fillOpacity: '1',
    fillRule: 'nonzero',
    strokeOpacity: 1,
    strokeWidth: strokeWidth,
    stroke: solidColor ? 'currentColor' : '',
  };

  return (
    <>
      <defs>
        <clipPath id={`${shapeId}_clip1`}>
          <path
            id={`${shapeId}_1`}
            d="M 0.484375 0.34375 L 29.515625 0.34375 L 29.515625 28.648438 L 0.484375 28.648438 Z M 0.484375 0.34375 "
            {...commonPathProps}
          />
        </clipPath>
      </defs>
      <g clipPath={`url(#${shapeId}_clip1)`}>
        <path
          id={`${shapeId}_2`}
          d="M 3.28125 28.683594 L 20.359375 28.683594 C 21.894531 28.683594 23.136719 27.4375 23.136719 25.90625 L 23.136719 20.65625 L 27.785156 10.046875 C 28.019531 10.238281 28.207031 10.492188 28.320312 10.78125 C 28.496094 11.230469 28.484375 11.71875 28.292969 12.160156 L 26.238281 16.867188 L 27.125 17.253906 L 29.183594 12.554688 C 29.480469 11.875 29.5 11.128906 29.226562 10.4375 C 29.015625 9.902344 28.652344 9.460938 28.1875 9.144531 L 28.804688 7.742188 C 29.234375 6.765625 28.785156 5.625 27.808594 5.195312 L 27.332031 4.984375 C 26.859375 4.777344 26.332031 4.765625 25.851562 4.953125 C 25.367188 5.140625 24.992188 5.503906 24.78125 5.980469 L 23.988281 7.785156 L 23.144531 9.71875 L 23.144531 7.460938 L 16.019531 0.34375 L 3.265625 0.34375 C 1.738281 0.34375 0.5 1.582031 0.5 3.109375 L 0.5 25.910156 C 0.5 27.4375 1.746094 28.683594 3.28125 28.683594 Z M 25.664062 6.367188 C 25.765625 6.128906 25.960938 5.949219 26.195312 5.851562 C 26.429688 5.757812 26.695312 5.761719 26.933594 5.863281 L 27.410156 6.078125 C 27.898438 6.289062 28.121094 6.863281 27.90625 7.351562 L 27.304688 8.714844 L 25.058594 7.730469 Z M 24.679688 8.621094 L 26.4375 9.386719 L 26.925781 9.605469 L 22.050781 20.734375 L 19.804688 19.75 Z M 21.617188 21.597656 L 19.917969 22.558594 L 19.46875 20.65625 Z M 16.304688 1.992188 L 21.488281 7.175781 L 18.097656 7.183594 C 18.097656 7.183594 18.097656 7.183594 18.09375 7.183594 C 17.617188 7.183594 17.164062 6.996094 16.824219 6.65625 C 16.484375 6.316406 16.300781 5.863281 16.300781 5.382812 Z M 1.46875 3.109375 C 1.46875 2.121094 2.277344 1.308594 3.265625 1.308594 L 15.34375 1.308594 L 15.339844 5.382812 C 15.339844 6.125 15.621094 6.820312 16.148438 7.339844 C 16.667969 7.859375 17.363281 8.148438 18.105469 8.148438 C 18.105469 8.148438 18.113281 8.148438 18.113281 8.148438 L 22.183594 8.144531 L 22.183594 11.925781 L 19.246094 18.636719 L 19.246094 18.59375 L 4.402344 18.59375 L 4.402344 19.5625 L 18.824219 19.5625 L 18.492188 20.328125 C 18.449219 20.425781 18.4375 20.535156 18.460938 20.628906 L 18.921875 22.585938 L 4.402344 22.585938 L 4.402344 23.554688 L 19.179688 23.554688 C 19.230469 23.632812 19.308594 23.699219 19.398438 23.742188 C 19.457031 23.765625 19.523438 23.785156 19.589844 23.785156 C 19.675781 23.785156 19.753906 23.765625 19.828125 23.722656 L 22.171875 22.394531 L 22.171875 25.910156 C 22.171875 26.914062 21.355469 27.722656 20.359375 27.722656 L 3.28125 27.722656 C 2.277344 27.722656 1.46875 26.90625 1.46875 25.910156 Z M 1.46875 3.109375 "
          {...commonPathProps}
        />
      </g>
      <path
        id={`${shapeId}_3`}
        d="M 11.820312 10.609375 L 19.234375 10.609375 L 19.234375 11.574219 L 11.820312 11.574219 Z M 11.820312 10.609375 "
        {...commonPathProps}
      />
      <path
        id={`${shapeId}_4`}
        d="M 4.402344 14.601562 L 19.230469 14.601562 L 19.230469 15.566406 L 4.402344 15.566406 Z M 4.402344 14.601562 "
        {...commonPathProps}
      />
    </>
  );
};

export const SmartContractIcon = ({
  shouldbegradient,
  transitionduration = 0.4,
  prefix,
  solidColor,
  iconType = 'normal',
  gradientColor,
  ...props
}: CustomSvgIconsProps): React.ReactElement => {
  const id = useId();
  const currColorId = `${prefix}_smartContractColorGradient_${id}`;
  const newColorId = `${prefix}_smartContractNewColorGradient_${id}`;
  const shapeId = `${prefix}_smartContractShape_${id}`;

  const theme = useTheme();
  const isLight = theme.palette.type === 'light';
  const colorsDark = {
    base: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.tealColors?.PLUS_2,
    },
  };
  const colorsLight = {
    base: {
      start: theme.palette?.greyColors?.PLUS_4,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.tealColors?.PLUS_3,
      stop: theme.palette.tealColors?.PLUS_2,
    },
  };
  const svgColors = isLight ? colorsLight : colorsDark;
  return (
    <SvgIcon
      {...props}
      width="40"
      height="40"
      zoomAndPan="magnify"
      viewBox="0 0 30 30.000001"
      preserveAspectRatio="xMidYMid meet">
      {solidColor ? (
        <SvgPath
          shapeId={shapeId}
          iconType={iconType}
          solidColor={solidColor}
        />
      ) : (
        <>
          <defs>
            <linearGradient
              style={{
                transition: `${transitionduration}s`,
              }}
              id={currColorId}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%">
              <stop offset="0" stopColor={svgColors.base.start} />
              <stop offset="1" stopColor={svgColors.base.stop} />
            </linearGradient>
            <linearGradient id={newColorId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0" stopColor={svgColors.hover.start} />
              <stop offset="1" stopColor={svgColors.hover.stop} />
            </linearGradient>
          </defs>

          <g
            style={{
              fill: `url("#${currColorId}")`,
            }}>
            <SvgPath
              shapeId={shapeId}
              iconType={iconType}
              solidColor={solidColor}
            />
          </g>
          <use
            xlinkHref={`#${shapeId}`}
            style={{
              fill: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 1 : 0,
            }}
          />
        </>
      )}
    </SvgIcon>
  );
};
